<div class="d-lg-flex">
    <ul
        ngbNav
        #nav="ngbNav"
        class="navbar nav sidebar fixed-left"
        [ngClass]="{ opened: open, 'transition-none': open && openSidebarSublevel, 'has-app-banner': showAppBanner }"
        orientation="vertical"
    >
        <li class="navbar-header mb-4 d-none d-lg-block">
            <a class="navbar-brand" [routerLink]="homepage">
                <img src="./assets/images/stella-images/edp_vertical_logo_light.svg" width="40" height="40" alt="Edp Online" class="img-fluid" />
            </a>
        </li>
        <li class="d-block d-lg-none">
            <div class="clearfix text-right">
                <button class="btn float-right d-block edp-color-neu-07" (click)="closeSidebar()">
                    <i class="icon icon-edponline-Bop-071 icon-2x close-icon" aria-hidden="true"></i>
                </button>
            </div>
        </li>
        <ng-container *ngFor="let item of mainMenu$ | async">
            <li [id]="item.reference || ''" *ngIf="item.visible">
                <ng-container *ngIf="!item.externalLink; else itemExternalLink">
                    <a class="nav-link" [ngClass]="{ active: item.isActive }" (click)="navigateTo(item)">
                        <ng-container *ngTemplateOutlet="itemContent"></ng-container>
                    </a>
                </ng-container>
                <ng-template #itemExternalLink>
                    <a class="nav-link" [ngClass]="{ active: item.isActive }"
                        [edpExternalLink]="item.externalLink | translate">
                        <ng-container *ngTemplateOutlet="itemContent"></ng-container>
                    </a>
                </ng-template>
                <ng-template #itemContent>
                    <i class="{{ item.icon }}" aria-hidden="true"></i>
                    <span class="mt-1" [ngClass]="{ 'ml-3': open }">{{ item.name | translate }}</span>
                    <i *ngIf="open && item.submenu.length" class="icon-edponline-Bop-078 ml-auto mr-2"
                        aria-hidden="true"></i>
                </ng-template>
            </li>
        </ng-container>
    </ul>
    <div
        class="sidebar-sub-level"
        [ngClass]="{
            opened: open && openSidebarSublevel,
            'd-none': !open || hideSubMenu,
            'd-lg-flex': !hideSubMenu,
            'has-app-banner': showAppBanner
        }"
    >
        <edp-e-sidebar-sub-level
            (closeSidebar)="closeSidebar()"
            (closeSidebarSublevel)="openSidebarSublevel = false"
            [contract]="contract"
        ></edp-e-sidebar-sub-level>
    </div>
</div>
